import { getOffset } from '../../../utilities'

const tooltip = (props) => {
    const offsetTop = offset => offset.top + offset.height + 3
    const offsetLeft = offset => offset.left + (offset.width / 2 - 18)
    
    let style = {}
    const parent = document.querySelector(props.parent)
    if (parent) {
        const offset = getOffset(parent)
        style = {
            top: `${offsetTop(offset)}px`,
            left: `${offsetLeft(offset)}px`
        }
    }

    let className = "tooltip elevation--6"
    if (props.show)
        className += " tooltip--shown"

    return <div className={`${className} ${props.className}`}
                style={style}>{props.children}</div>
}

export default tooltip